// extracted by mini-css-extract-plugin
export default {"icon__start__date":"ReservationSummary_icon__start__date__cUwjk"};